<template>
  <section id="footer-page" class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div class="text-center text-muted mb-4">
                <small>Đổi mật khẩu</small>
              </div>
              <form role="form">
                <base-input alternative
                            type="password"
                            v-model='user.old_password'
                            placeholder="Mật khẩu cũ"
                            addon-left-icon="ni ni-lock-circle-open">
                </base-input>
                <base-input alternative
                            type="password"
                            v-model='user.new_password'
                            placeholder="Mật khẩu mới"
                            addon-left-icon="ni ni-lock-circle-open">
                </base-input>
                <base-input alternative
                            type="password"
                            v-model='user.confirm_new_password'
                            placeholder="Nhập lại mật khẩu mới"
                            addon-left-icon="ni ni-lock-circle-open">
                </base-input>
                <div class="text-center">
                    <base-button @click="validate(); validate_password(); set_message(); reset_password()" type="primary" class="my-4">Đổi mật khẩu</base-button>
                </div>
              </form>              
              <div v-if="message != ''" class="alert alert-warning" role="alert">
                {{message}}
              </div>
              <!-- <div>{{data_user}}</div> -->
            </template>
          </card>
          <!-- <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <small>Quên mật khẩu?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <a href="/register" class="text-light">
                <small>Tạo tài khoản</small>
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
var required_field = ['old_password', 'confirm_new_passwod', 'new_password']
export default {
  data() {
    return {
      user: {
        old_password: '',
        new_password: '',
        confirm_new_password: '',

      },
      errors: {}
    };
  },
  computed: 
  {
    ...mapState("user",{
        status: state => state.status,
        message: state => state.message
    }),
    // data_user: function(){
    //   // console.log(this.$store.state.user)
    //   return this.$store.state.user
    // }
  },  
  methods: {
    login() {
      if (this.status == 'authenticate'){        
        this.$store.dispatch('user/login', this.user)
      }
    },
    validate: function(){
      var missing_value = false
      required_field.forEach((field) =>{
        if (this.user[field] == ''){
          this.errors['missing_field'] = 'Điền đầy đủ thông tin các trường'
          missing_value = true
        }
      })
      if (!missing_value){
        delete this.errors['missing_field']
      }
    },
    validate_password: function(){      
      // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // if (re.test(String(this.user.email).toLowerCase())){
      //   delete this.errors['email']
      // }else{
      //   this.errors['email'] = "Email sai định dạng"
      // }
      // console.log(this.new_password.length)
      
      if (this.user.new_password.length< 6){
        this.errors['password_short'] = 'Mật khẩu mới quá ngắn'
      }else{
        delete this.errors['password_short']
      }

      if (this.user.new_password !== this.user.confirm_new_passwod){
        this.errors['password'] = 'Mật khẩu mới không khớp'
      }else{
        delete this.errors['password']
      }

    },
    set_message: function(){
      var key  = Object.keys(this.errors)[0];
      if ( key == undefined || key == ''){        
        this.$store.dispatch('user/set_message', '')
        this.$store.dispatch('user/set_status', "authenticate")      
      }else{          
        this.$store.dispatch('user/set_message', this.errors[key])
        this.$store.dispatch('user/set_status', "validate")
      }
    },
    reset_password: function(){
      this.$store.dispatch('user/reset_password_api', this.user)
    }
  }
};
</script>
<style>
button.btn.btn-icon.btn-neutral {
  font-size: 13px;
} 
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue